import React from 'react';
import { Truck, Package, RotateCcw, Clock, MapPin, Shield } from 'lucide-react';
import Header from './components/Header13';
import Footer from './components/Footer13';

const ShippingAndExchange13 = () => {
    const shippingOptions = [
        { icon: Truck, title: 'Standard Shipping', time: '7-10 business days', cost: 'Free above ₹2,000', desc: 'Reliable delivery across India. ₹99 for orders below ₹2,000.' },
        { icon: Package, title: 'Express Shipping', time: '3-5 business days', cost: '₹249', desc: 'Priority handling and faster delivery for urgent orders.' },
        { icon: MapPin, title: 'International Shipping', time: '10-15 business days', cost: 'Calculated at checkout', desc: 'We ship to 15+ countries. Customs duties may apply.' },
    ];

    const exchangeSteps = [
        { step: '1', title: 'Initiate Return', desc: 'Contact us within 7 days of delivery with your order ID and reason for return.' },
        { step: '2', title: 'Ship the Product', desc: 'Pack the item in original packaging and ship it back using our prepaid return label.' },
        { step: '3', title: 'Quality Check', desc: 'Our team inspects the returned item to ensure it is in original condition.' },
        { step: '4', title: 'Refund Processed', desc: 'Refund is initiated within 3-5 business days after quality verification.' },
    ];

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&family=Mulish:wght@300;400;600&display=swap');`}</style>
            <div style={{ fontFamily: "'Mulish', sans-serif" }} className="min-h-screen bg-[#FBF8F4]">
                <Header />
                <main style={{ paddingTop: '72px' }}>
                    <div style={{ backgroundColor: '#F7F3ED', padding: '48px 20px', textAlign: 'center', borderBottom: '1px solid #E7E0D6' }} className="md:py-20">
                        <Truck size={36} style={{ color: '#C2410C', margin: '0 auto 16px' }} />
                        <h1 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '32px', fontWeight: 700, color: '#1C1917' }} className="md:text-5xl">Shipping & Returns</h1>
                        <p style={{ fontSize: '14px', color: '#78716C', marginTop: '12px' }}>Everything you need to know about delivery and returns</p>
                    </div>

                    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '48px 20px 80px' }}>
                        {/* Shipping Options */}
                        <div style={{ marginBottom: '56px' }}>
                            <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '24px', fontWeight: 700, color: '#1C1917', marginBottom: '24px' }} className="lg:text-3xl">Shipping Options</h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {shippingOptions.map((option, i) => (
                                    <div key={i} style={{ backgroundColor: '#F7F3ED', borderRadius: '8px', padding: '28px', border: '1px solid #E7E0D6' }}>
                                        <option.icon size={28} style={{ color: '#C2410C', marginBottom: '16px' }} />
                                        <h3 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '17px', fontWeight: 700, color: '#1C1917', marginBottom: '8px' }}>{option.title}</h3>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                                            <Clock size={14} style={{ color: '#C2410C' }} />
                                            <span style={{ fontSize: '13px', color: '#C2410C', fontWeight: 600 }}>{option.time}</span>
                                        </div>
                                        <p style={{ fontSize: '14px', fontWeight: 600, color: '#1C1917', marginBottom: '8px' }}>{option.cost}</p>
                                        <p style={{ fontSize: '13px', color: '#78716C', lineHeight: 1.6 }}>{option.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Handcraft Note */}
                        <div style={{ backgroundColor: '#C2410C', borderRadius: '8px', padding: '28px', marginBottom: '56px', color: '#FBF8F4' }}>
                            <h3 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '18px', fontWeight: 700, marginBottom: '12px' }}>A Note About Handcrafted Products</h3>
                            <p style={{ fontSize: '14px', lineHeight: 1.7, opacity: 0.9 }}>
                                Since every product is handcrafted, slight variations in color, pattern, and texture are natural and expected. These variations are a hallmark of authentic handmade products and make each piece unique. Please allow 3-5 additional days for made-to-order items.
                            </p>
                        </div>

                        {/* Returns Process */}
                        <div style={{ marginBottom: '56px' }}>
                            <h2 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '24px', fontWeight: 700, color: '#1C1917', marginBottom: '24px' }} className="lg:text-3xl">Returns & Exchange Process</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                                {exchangeSteps.map((step, i) => (
                                    <div key={i} style={{ textAlign: 'center' }}>
                                        <div style={{ width: '48px', height: '48px', borderRadius: '50%', backgroundColor: '#C2410C', color: '#FFF', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontFamily: "'Merriweather', Georgia, serif", fontSize: '18px', fontWeight: 700 }}>
                                            {step.step}
                                        </div>
                                        <h3 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '16px', fontWeight: 700, color: '#1C1917', marginBottom: '8px' }}>{step.title}</h3>
                                        <p style={{ fontSize: '13px', color: '#78716C', lineHeight: 1.6 }}>{step.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Non-returnable Items */}
                        <div style={{ backgroundColor: '#F7F3ED', borderRadius: '8px', padding: '28px', border: '1px solid #E7E0D6' }}>
                            <h3 style={{ fontFamily: "'Merriweather', Georgia, serif", fontSize: '18px', fontWeight: 700, color: '#1C1917', marginBottom: '16px' }}>Non-Returnable Items</h3>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                                {[
                                    'Custom and made-to-order products',
                                    'Items that have been worn, washed, or altered',
                                    'Products returned after 7 days of delivery',
                                    'Items without original packaging and tags',
                                ].map((item, i) => (
                                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#78716C', marginBottom: '10px' }}>
                                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#C2410C', flexShrink: 0 }} />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default ShippingAndExchange13;
